import React, { useState } from 'react';
import { Menu, X, Briefcase } from 'lucide-react';
export type ServiceType = 'foretagsbestallning' | 'manadens_meny' | 'catering_event';
interface NavigationProps {
  onOrderClick: (type: ServiceType) => void;
  onJobsClick: () => void;
  onBusinessOrder?: () => void;
  onScrollToCatalog?: () => void;
}
export function Navigation({
  onOrderClick,
  onJobsClick,
  onBusinessOrder,
  onScrollToCatalog
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleLinkClick = (type: ServiceType) => {
    if (type === 'foretagsbestallning' && onBusinessOrder) {
      onBusinessOrder();
    } else if (type === 'catering_event' && onScrollToCatalog) {
      onScrollToCatalog();
    } else {
      onOrderClick(type);
    }
    setIsOpen(false);
  };
  const handleJobsClick = () => {
    onJobsClick();
    setIsOpen(false);
  };
  const links: {
    label: string;
    type: ServiceType;
  }[] = [{
    label: 'Företagsbeställning',
    type: 'foretagsbestallning'
  }, {
    label: 'Catering & Event',
    type: 'catering_event'
  }];
  return <nav className="sticky top-0 z-40 w-full bg-[#F2EDE4] border-b border-[#7C8062]/15 shadow-sm" data-id="element-512">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-513">
        <div className="flex justify-center items-center h-12" data-id="element-514">
          {/* Desktop Menu - Centered */}
          <div className="hidden md:flex items-center space-x-10" data-id="element-515">
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-516">
                {link.label}
              </button>)}
            <button onClick={handleJobsClick} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-517">
              <Briefcase className="w-4 h-4" data-id="element-518" />
              Jobba hos oss
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-519">
            <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 focus:outline-none transition-colors" aria-label="Meny" aria-expanded={isOpen} data-id="element-520">
              {isOpen ? <X className="h-5 w-5" data-id="element-521" /> : <Menu className="h-5 w-5" data-id="element-522" />}
              <span className="text-sm font-medium tracking-wide" data-id="element-523">
                {isOpen ? 'Stäng' : 'Meny'}
              </span>
            </button>
          </div>
        </div>
      </div>

      {isOpen && <div className="md:hidden bg-[#F2EDE4] border-t border-[#7C8062]/10 animate-in slide-in-from-top-2 duration-200" data-id="element-524">
          <div className="px-4 pt-3 pb-4 space-y-1" data-id="element-525">
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-526">
              Beställ & Tjänster
            </p>
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-527">
                {link.label}
              </button>)}
            <div className="h-px bg-[#7C8062]/10 my-2" data-id="element-528" />
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-529">
              Karriär
            </p>
            <button onClick={handleJobsClick} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-530">
              <Briefcase className="w-5 h-5" data-id="element-531" />
              Jobba hos oss
            </button>
          </div>
        </div>}
    </nav>;
}